import React from 'react';
import { AgreementVisit } from '../../../../models/AgreementMetadata';
import moment from 'moment';
import styles from './agreement_visits.module.scss';

type Props = {
  visit: AgreementVisit;
}

/**
 * Renders a single listable visit to an agreement.
 */
export const AgreementVisitListItem: React.FC<Props> = ({ visit }) => (
  <li className={styles.item}>
    <span>{moment(visit.date).format('ddd D MMM YYYY HH:mm')}</span>
  </li>
)